import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UrlService } from 'src/app/services/util/url.service';

@Component({
    selector: 'app-instance-endpoints',
    templateUrl: './instance-endpoints.component.html',
    styleUrls: ['./instance-endpoints.component.scss'],
    standalone: false
})
export class InstanceEndpointsComponent implements OnInit {

  @Input() data: any;

  constructor(public urlService: UrlService, private toastrService: ToastrService) { }

  ngOnInit(): void {
  }

  onCopiedUrl(): void {
    this.toastrService.success('URL Copied');
  }
}
